import React from 'react'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import 'bootstrap/dist/css/bootstrap.min.css'
import {StatusOptionComponentModel} from '../../../../entities/component.entity'
import PrimaryButton from '../common/buttons/PrimaryButton'

interface FormValues {
  status: number
}

interface ChangeStatusModalProps {
  isOpen: boolean
  onClose: () => void
  handleSubmit: (values: FormValues, resetForm: () => void) => void
  currentStatus: number
  statuses: StatusOptionComponentModel[]
}

const ChangeStatusModal: React.FC<ChangeStatusModalProps> = ({
  isOpen,
  onClose,
  handleSubmit,
  currentStatus,
  statuses,
}) => {
  const initialValues: FormValues = {
    status: currentStatus,
  }

  return (
    <>
      {isOpen && (
        <div
          onClick={onClose}
          className='modal-backdrop show'
          style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
        />
      )}
      <div className={`modal fade ${isOpen ? 'show d-block' : ''}`} tabIndex={-1}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Change Status</h5>
              <button type='button' className='btn-close' onClick={onClose}></button>
            </div>
            <div className='modal-body'>
              <Formik
                initialValues={initialValues}
                onSubmit={(values, {resetForm}) => {
                  handleSubmit(values, resetForm)
                  onClose()
                }}
              >
                {({values}) => (
                  <Form>
                    <div className='mb-4'>
                      <label className='form-label'>Status</label>
                      <Field as='select' name='status' className='form-control'>
                        {statuses?.map(({value, label, disabled}) => (
                          <option key={value} value={value} disabled={disabled}>
                            {label}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name='status' component='div' className='text-danger' />
                    </div>
                    <div className='modal-footer'>
                      <PrimaryButton type='submit' disabled={values.status === initialValues.status}>
                        Update Status
                      </PrimaryButton>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ChangeStatusModal
